/* eslint-disable camelcase */
import moment from 'moment'
import router from '../../router/router'
import { resetStateToDefault } from '../../utils'
import {
  adicionarEventoParaPrevinirFechamentoDaPagina,
  removerEventoParaPrevinirFechamentoDaPagina,
  tratarErroRepp,
  tratarErroInformacoesMarcacao,
  tratarErroEnvioInfosExtras,
  tratarErroValidacaoPreMarcacao,
  chaveInfosExtrasStorage,
  verificarESetarInfosExtrasNoLocalStorage,
  verificarERemoverInfosExtrasDoLocalStorage
} from './utils'
import { Http } from 'vue-resource'
import {
  gerarUrlValidacoesPreMarcacao,
  gerarUrlMarcacao,
  gerarUrlComprovanteDados,
  gerarUrlInfosExtrasMarcacao,
  gerarUrlInfosExtraMarcacoesAudios,
  gerarUrlComprovantePdf
} from '../../api'
import * as Sentry from '@sentry/vue'
import i18n from '../../locales/i18n'
import { formatarObjetoWebParaSentry } from '../../sentry.ts'

const defaultState = () => ({
  empregadoId: null,
  localId: null,
  timeZoneLocalDeTrabalho: null,
  timeZoneDaGeolocalizacao: null,
  erroDeGeolocalizacao: null,
  opcoesDeMarcacao: {
    ativarMarcacaoVoz: null,
    omitirBotoesDePausa: null,
    forcarModalDeRequisicaoVoz: null,
    exibirModalDeConfirmacaoDaMarcacao: null
  },
  tipoDoColetor: '02',
  marcacaoId: null,
  horarioColetor: null,
  latitude: null,
  longitude: null,
  acuracia: null,
  marcacoesDoDia: null, //
  momentoDaJornada: null,
  processandoPonto: null,
  comprovanteMarcacao: null,
  audioGravado: null,
  localDeTrabalhoMarcacao: null,
  horarioDaGeolocalizacaoCarregado: null,
  erroEnvioInfosExtras: null,
  horarioDadosMarcacao: null,
  mostrarRelogio: false,
  validandoPreMarcacao: false,
  tentativasValidacaoPreMarcacao: 0,
  tentativasBuscarDadosDaMarcacao: 0,
  erroBuscarDados: false,
  tentativasEnviarInfosExtrasEmSegundoPlano: 0,
  tentativasEnvioInfosExtras: 0
})

const mutations = {
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  atribuiEmpregadoId (state, empregadoId) {
    state.empregadoId = empregadoId
  },
  atribuilocalId (state, local) {
    state.localId = local
  },
  atribuiTimeZoneLocalDeTrabalho (state, timezone) {
    state.timeZoneLocalDeTrabalho = timezone
  },
  atribuiTimeZoneDaGeolocalizacao (state, timezone) {
    state.timeZoneDaGeolocalizacao = timezone
  },
  atribuiErroDeGeolocalizacao (state, erro) {
    state.erroDeGeolocalizacao = erro
  },
  atribuiHorarioColetor (state, horario) {
    state.horarioColetor = horario
  },
  atribuiHorarioDispositivo (state, horario) {
    state.horarioDispositivo = horario
  },
  atribuiInformacoesGeolocalizacao (state, geolocalizacao) {
    state.latitude = geolocalizacao.latitude
    state.longitude = geolocalizacao.longitude
    state.acuracia = geolocalizacao.accuracy
  },
  atribuiMarcacoesDoDia (state, marcacoes) {
    state.marcacoesDoDia = marcacoes
  },
  atribuiMarcacaoId (state, id) {
    state.marcacaoId = id
  },
  atribuiProcessandoPonto (state, status) {
    state.processandoPonto = status
  },
  atribuiMomentoDaJornada (state, jornada) {
    state.momentoDaJornada = jornada
  },
  atribuiComprovanteMarcacao (state, marcacao) {
    state.comprovanteMarcacao = marcacao
  },
  atribuiAudioGravado (state, audio) {
    state.audioGravado = audio
  },
  atribuiLocalDeTrabalhoMarcacao (state, local) {
    state.localDeTrabalhoMarcacao = local
  },
  atribuiOpcoesDeMarcacao (state, opcoes) {
    state.opcoesDeMarcacao.ativarMarcacaoVoz = opcoes.ativar_marcacao_com_voz_na_web
    state.opcoesDeMarcacao.omitirBotoesDePausa = opcoes.omitir_botoes_de_pausa_no_registro
    state.opcoesDeMarcacao.forcarModalDeRequisicaoVoz = opcoes.forcar_modal_de_requisicao_de_voz
    state.opcoesDeMarcacao.exibirModalDeConfirmacaoDaMarcacao = opcoes.exibir_modal_de_confirmacao_da_marcacao
  },
  atribuiHorarioDoLocalCarregado (state, status) {
    state.horarioDoLocalCarregado = status
  },
  atribuiHorarioDaGeolocalizacaoCarregado (state, status) {
    state.horarioDaGeolocalizacaoCarregado = status
  },
  atribuiErroEnvioInfosExtras (state, status) {
    state.erroEnvioInfosExtras = status
  },
  atribuiMostrarRelogio (state, status) {
    state.mostrarRelogio = status
  },
  atribuiValidandoPreMarcacao (state, status) {
    state.validandoPreMarcacao = status
  },
  atribuiTentativasValidacaoPreMarcacao (state, status) {
    state.tentativasValidacaoPreMarcacao = status
  },
  atribuiTentativasBuscarDadosDaMarcacao (state, status) {
    state.tentativasBuscarDadosDaMarcacao = status
  },
  atribuiErroBuscarDados (state, status) {
    state.erroBuscarDados = status
  },
  atribuiHorarioDadosMarcacao (state, horario) {
    state.horarioDadosMarcacao = horario
  },
  atribuiTentativasEnviarInfosExtrasEmSegundoPlano (state, tentativas) {
    state.tentativasEnviarInfosExtrasEmSegundoPlano = tentativas
  },
  atribuiTentativasEnvioInfosExtras (state, tentativas) {
    state.tentativasEnvioInfosExtras = tentativas
  }
}

const actions = {
  async validarPreMarcacao ({ state, commit }, timeout = 5000) {
    try {
      const res = await Http.get(gerarUrlValidacoesPreMarcacao(state.empregadoId, state.localId), {timeout})
      const { timezone } = res.body
      const localDeTrabalho = state.localDeTrabalhoMarcacao.nome
      commit('atribuiTentativasValidacaoPreMarcacao', 0)
      commit('localDeTrabalhoUltimoPonto', localDeTrabalho, {root: true})
      commit('timeZoneLocalDeTrabalho', timezone, {root: true})
      setTimeout(() => {
        commit('atribuiValidandoPreMarcacao', false)
      }, 500)
      return res
    } catch (e) {
      tratarErroValidacaoPreMarcacao(e)
    }
  },
  async fazerMarcacao ({ commit, state, dispatch, rootState }) {
    commit('atribuiProcessandoPonto', true)
    const definirTimezoneDoColetor = () => {
      const { aceita_timezone_do_coletor } = state.localDeTrabalhoMarcacao

      if (
        state.timeZoneDaGeolocalizacao &&
        aceita_timezone_do_coletor) {
        console.warn(i18n.t('componentes.marcacao.state.timeZoneGlobal'))
        return state.timeZoneDaGeolocalizacao
      }
      console.warn(i18n.t('componentes.marcacao.state.timeZoneLocal'))
      return state.timeZoneLocalDeTrabalho
    }
    const parametros = {
      empregado: state.empregadoId,
      localDeTrabalho: state.localId,
      tipoDoColetor: state.tipoDoColetor,
      timezoneDoColetor: definirTimezoneDoColetor(),
      momento_da_jornada: state.momentoDaJornada
    }

    adicionarEventoParaPrevinirFechamentoDaPagina()

    try {
      const response = await Http.post(gerarUrlMarcacao(), parametros)
      const { created } = response.body

      commit('atribuiMarcacaoId', created)
      commit('atribuiTentativasEnvioInfosExtras', 0)
      dispatch('enviarInfosExtrasMarcacoes', {})

      const [hora, minuto, segundos] = state.horarioColetor?.split(':')

      const horarioColetorParaSalvarNoStorage = hora && minuto && segundos
        ? moment().set({hour: hora, minute: minuto, second: segundos}).toISOString()
        : new Date().toISOString()

      const jornada = rootState.sincronizador?.sincronizacaoUsuario?.jornada_do_dia?.dia || moment().format('YYYY-MM-DD')

      const marcacaoParaStorage = {
        'jornada': jornada,
        'empregado_id': state.empregadoId,
        'id': created,
        'momento_da_jornada': state.momentoDaJornada,
        'horario': horarioColetorParaSalvarNoStorage,
        'pontoArmazenado': true,
        origem: 'OUTRO'

      }
      const marcacoesEmpregadoStorage = JSON.parse(window.localStorage.getItem(state.empregadoId))

      if (marcacoesEmpregadoStorage && marcacoesEmpregadoStorage.length) {
        window.localStorage.setItem(state.empregadoId, JSON.stringify([...marcacoesEmpregadoStorage, marcacaoParaStorage]))
      } else {
        window.localStorage.setItem(state.empregadoId, JSON.stringify([marcacaoParaStorage]))
      }

      const timeZoneDoPonto = parametros.timezoneDoColetor || state.timeZoneLocalDeTrabalho
      const localDeTrabalho = state.localDeTrabalhoMarcacao.nome

      commit('timezoneUltimoPonto', timeZoneDoPonto, {root: true})
      commit('localDeTrabalhoUltimoPonto', localDeTrabalho, {root: true})
    } catch (e) {
      tratarErroRepp(e, 'MC')
      commit('atribuiProcessandoPonto', false)
    }
  },
  async enviarInfosExtrasMarcacoes ({ state, dispatch }, { tempoParaFazerRequisicao = 3000, urlBaseParaRetry = false }) {
    const naoPossuiDadosGeolocalizacao =
      !state.latitude || !state.longitude || !state.acuracia || state.erroDeGeolocalizacao
    let parametrosEnvio

    if (naoPossuiDadosGeolocalizacao) {
      parametrosEnvio = [{
        marcacao_id: state.marcacaoId,
        momento_da_jornada: state.momentoDaJornada,
        ponto_sequencial: false,
        ponto_com_qrcode: false,
        horario_interno_do_dispositivo: moment(new Date()).toDate().toISOString().replace('Z', ''),
        horario_interno_do_coletor: moment(new Date()).toDate().toISOString().replace('Z', ''),
        localizacao_erro: state.erroDeGeolocalizacao || 'PERMISSAO_NEGADA'
      }]
    } else {
      parametrosEnvio = [
        {
          marcacao_id: state.marcacaoId,
          momento_da_jornada: state.momentoDaJornada,
          ponto_sequencial: false,
          ponto_com_qrcode: false,
          horario_interno_do_dispositivo: moment(new Date()).toDate().toISOString().replace('Z', ''),
          horario_interno_do_coletor: moment(new Date()).toDate().toISOString().replace('Z', ''),
          localizacao: {
            coordenadas: {
              latitude: state.latitude,
              longitude: state.longitude
            },
            acuracia: state.acuracia,
            manipulacao_detectada: false
          }
        }
      ]
    }
    const infoExtraStorage = JSON.parse(window.localStorage.getItem(chaveInfosExtrasStorage))

    const verificarEEnviarAudioDaMarcacao = () => {
      if (state.audioGravado) {
        setTimeout(() => {
          dispatch('enviarInfosExtrasMarcacoesAudio')
        }, 1000)
      }
    }
    try {
      await Http.put(gerarUrlInfosExtrasMarcacao(), parametrosEnvio, {
        timeout: tempoParaFazerRequisicao,
        urlBaseParaRetry: urlBaseParaRetry
      })
      dispatch('buscarComprovanteMarcacaoDados')
      removerEventoParaPrevinirFechamentoDaPagina()
      verificarERemoverInfosExtrasDoLocalStorage(state, infoExtraStorage, chaveInfosExtrasStorage)
      verificarEEnviarAudioDaMarcacao()
    } catch (e) {
      verificarESetarInfosExtrasNoLocalStorage(state, infoExtraStorage, chaveInfosExtrasStorage, parametrosEnvio)
      tratarErroEnvioInfosExtras(e)
    }
  },
  async enviarInfosExtrasMarcacoesAudio ({ state }) {
    const formData = new FormData()

    const blob = state.audioGravado
    formData.append('arquivos', blob, `${state.marcacaoId}.m4a`)

    try {
      await Http.put(gerarUrlInfosExtraMarcacoesAudios(), formData)
    } catch (e) {
    }
  },
  async buscarComprovanteMarcacaoDados ({ commit, state, dispatch }, timeout = 5000) {
    try {
      const response = await Http.get(gerarUrlComprovanteDados(state.marcacaoId), {timeout})
      const { horarioDaMarcacao } = response.body

      const marcacoesEmpregadoStorage = JSON.parse(window.localStorage.getItem(state.empregadoId))

      const marcacoesRemapeadasComHorarioDoBack = marcacoesEmpregadoStorage.map(marcacaoStorage => {
        if (marcacaoStorage.id === state.marcacaoId) {
          const marcaocaoComHorarioDoBack = {
            ...marcacaoStorage,
            horario: horarioDaMarcacao
          }
          return marcaocaoComHorarioDoBack
        } else {
          return marcacaoStorage
        }
      })

      window.localStorage.setItem(state.empregadoId, JSON.stringify(marcacoesRemapeadasComHorarioDoBack))

      const horarioDoColetor = moment.utc(horarioDaMarcacao).toISOString().replace('Z', '')
      commit('atribuiHorarioDadosMarcacao', horarioDoColetor)
      commit('atribuiComprovanteMarcacao', response.body)
      commit('atribuiProcessandoPonto', false)
      commit('atribuiTentativasBuscarDadosDaMarcacao', 0)
      router.push({ name: 'confirmacaoPonto' })
    } catch (e) {
      tratarErroInformacoesMarcacao(e)
    }
  },
  async buscarComprovanteMarcacaoPdf ({ state, rootState }, {id}) {
    const { tokenColetor } = rootState.accessData.coletor
    if (!tokenColetor) {
      Sentry.captureEvent({
        message: 'Buscar comprovante marcação PDF',
        contexts: {
          localStorage: {
            web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
          }
        }
      })
    }

    const link = document.createElement('a')
    const headers = new Headers()

    document.body.appendChild(link)

    headers.append('Authorization', `Bearer ${tokenColetor}`)
    fetch(gerarUrlComprovantePdf(id), { headers })
      .then(response => response.blob())
      .then(blobby => {
        const objUrl = window.URL.createObjectURL(blobby)

        link.href = objUrl
        link.download = `comprovante_ponto_${id}`
        link.click()

        URL.revokeObjectURL(objUrl)
      })
      .catch(e => {
        tratarErroRepp(e, 'NC')
      })
  },
  async enviarInfosExtrasEmSegundoPlano ({ state, dispatch, commit }, timeout = 5000) {
    const infoExtraStorage = JSON.parse(window.localStorage.getItem(chaveInfosExtrasStorage))
    if (!infoExtraStorage?.length) return
    try {
      await Http.put(gerarUrlInfosExtrasMarcacao(), infoExtraStorage, {timeout})
      setTimeout(() => {
        window.localStorage.removeItem(chaveInfosExtrasStorage)
      }, 500)
    } catch (e) {
      const tentativasEnvio = state.tentativasEnviarInfosExtrasEmSegundoPlano
      const erro = e.status === 0 ? `${e.status} - timeout` : e.status

      if (tentativasEnvio === 3) {
        Sentry.captureEvent({
          message: `Infos-Extras-Backgound: falhou ${tentativasEnvio} vezes com o erro status ${erro}`
        })

        commit('atribuiTentativasEnviarInfosExtrasEmSegundoPlano', 0)
        return
      }
      const dataOntem = moment(moment()).subtract(1, 'day')
      infoExtraStorage.forEach(ie => {
        const infoExtraAntiga = moment(ie.horario_interno_do_coletor).isBefore(dataOntem)
        if (infoExtraAntiga) {
          const index = infoExtraStorage.indexOf(ie)
          infoExtraStorage.splice(index, 1)
          setTimeout(() => {
            window.localStorage.setItem(chaveInfosExtrasStorage, JSON.stringify(infoExtraStorage))
          }, 500)
        }
      })
      commit('atribuiTentativasEnviarInfosExtrasEmSegundoPlano', tentativasEnvio + 1)
      dispatch('enviarInfosExtrasEmSegundoPlano')
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations
}
